import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: start;
  align-self: center;
  gap: 2.5rem;
  padding: 0 3rem;
  text-align: center;
  max-width: 1100px;

  @media (max-width: 600px) {
    padding: 0 1.5rem;
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;

  button {
    flex: 1;
    padding: 0.75rem 1.25rem;
  }

  @media (max-width: 1100px) {
    flex-direction: column;
  }
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`
